<template>
  <b-modal
    ref="modal"
    body-class="!p-[24px] text-black w-full !rounded-[12px]"
    content-class="!rounded-[12px]"
    size="md"
    centered
    hide-footer
    hide-header
    @hide="reset"
  >
    <img
      :src="iconSrc"
      alt="warning packet removal"
      class="w-[98px] mx-auto mb-[24px]"
    >
    <h3
      class="text-[18px] font-medium text-center text-[#0A0A0A]"
      :class="!awbBeenDownloaded ? 'mb-[24px]' : 'mb-[4px]'"
    >
      Konfirmasi Pembatalan
    </h3>
    <p
      v-if="awbBeenDownloaded"
      class="text-[14px] text-center mb-[24px] text-[#737373]"
    >
      Label Resi sudah diunduh, pastikan komunikasi dengan mitra untuk menghindari kesalahan packing.
    </p>
    <UITable
      :columns="columns"
      :items="data"
      header-class="hidden"
      item-key="outbound_detail_id"
      container-class="mb-[24px] !rounded-[8px]"
      max-height="120px"
    >
      <template #cell(awb)="{ item }">
        <span>{{ item.awb || '(Resi tidak diisi)' }}</span>
      </template>
      <template #cell(total_item)="{ item }">
        <span class="bg-[#F5F5F5] px-[10px] py-[2px] rounded-[10px] text-[14px] text-[#0A0A0A]">
          {{ computeTotalItem(item.products) }} Item
        </span>
      </template>
    </UITable>
    <div class="grid gap-[8px] sm:grid-cols-2">
      <Button
        class="w-full px-[16px] py-[8px] h-auto"
        outline
        :disabled="isSubmitting"
        @click="handleCloseModal"
      >
        Batal
      </Button>
      <Button
        class="w-full px-[16px] py-[8px] h-auto flex justify-center items-center gap-[8px]"
        variant="primary"
        :disabled="isSubmitting"
        @click="handleSave"
      >
        <b-spinner
          v-if="isSubmitting"
          class="w-[16px] h-[16px]"
          small
        />
        Lanjutkan
      </Button>
    </div>
  </b-modal>
</template>

<script>
/**
 * Confirmation modal for canceling packing submission orders.
 * @example
 * this.$refs.modalConfirmCancelOrder.show({ data: items, onSaveFn: async () => {} })
 */
import { Button, Table as UITable } from '@/@core/components/ui'

export default {
  components: {
    Button,
    UITable,
  },
  data() {
    return {
      data: [],
      isSubmitting: false,
      awbBeenDownloaded: false,
      iconSrc: 'https://storage.googleapis.com/komerce/core/icon-popup-warning.png',
      columns: [
        {
          key: 'awb',
          tdClass: '!p-[8px]',
        },
        {
          key: 'total_item',
          tdClass: 'text-right !p-[8px]',
        },
      ],
    }
  },
  computed: {
    packetType() {
      return (this.data.index || 0) + 1
    },
  },
  created() {
    this.onSaveFn = null
  },
  methods: {
    show({
      data,
      awbBeenDownloaded,
      onSaveFn,
    }) {
      this.data = data || []
      this.onSaveFn = onSaveFn
      this.isSubmitting = false
      this.awbBeenDownloaded = awbBeenDownloaded
      this.$refs.modal.show()
    },
    reset() {
      this.data = []
      this.onSaveFn = null
      this.isSubmitting = false
      this.awbBeenDownloaded = false
    },
    hide() {
      this.reset()
      this.$refs.modal.hide()
    },
    handleCloseModal() {
      if (this.isSubmitting) return
      this.hide()
    },
    async handleSave() {
      if (this.isSubmitting) return
      this.isSubmitting = true
      try {
        const { data } = this
        if (this.onSaveFn) {
          await this.onSaveFn({
            data,
          })
        }
        this.hide()
      } catch (error) {
        console.error('Error while saving:', error)
      } finally {
        this.isSubmitting = false
      }
    },
    computeTotalItem(products) {
      if (!Array.isArray(products)) return 0
      return products.reduce((total, product) => total + product.total_item, 0)
    },
  },
}
</script>
